import { API } from 'src/constants/api';
import { axiosInterceptor } from 'src/utils/interceptors';

export const permissionList = async (payload?: any, signal?: any) => {
    const uri = API.Permissions.list + payload;
    const response = await axiosInterceptor.get(uri, { signal: signal });
    return response;
};
export const permissionUpdate = async (payload?: any) => {
    const uri = API.Permissions.update;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};

export const createPermission = async (payload?: any) => {
    const uri = API.Permissions.create;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};

export const deletePermission = async (payload?: any) => {
    const uri = API.Permissions.delete + payload;
    const response = await axiosInterceptor.delete(uri);
    return response;
};
